import { takeEvery, call, all, put } from "redux-saga/effects"
import { ClubsActions } from "./action"
import axios from "axios"
import { API_URL } from "../../utils/Constant"

export const ClubsSagas = function* (){
    yield all([
        takeEvery(ClubsActions.GET_CLUBS,getClubs),
        takeEvery(ClubsActions.GET_CLUBS_DETAIL,getClubsDetails)
    ])
}

const getClubs = function*(data){
    try{
        const result = yield call(()=>axios.get(`${API_URL}/club-headings`));
        
        yield put({
            type:ClubsActions.SET_CLUBS,
            payload:result.data,
        });

    }catch(error){
        console.error("error",error);
        
        
    }
}

const getClubsDetails = function* (action) {
    try {
      const { id } = action.payload;
      
      const result = yield call(() => axios.get(`${API_URL}/clubs/${id}`));
      
  
      yield put({
        type: ClubsActions.SET_CLUBS_DETAIL,
        payload: result.data,
      });
    } catch (error) {
      console.error("Error fetching club details:", error);
    }
  };




  